export default __webpack_public_path__ + "static/media/hero-how-to.0c8d92f0.svg";